import { SHA256Hash } from '../../../../tracking/utilities/SHA256Hash';

export class HashedSignupData {
  email: SHA256Hash;
  phoneNumber: SHA256Hash;

  constructor(email: SHA256Hash, phoneNumber: SHA256Hash) {
    this.email = email;
    this.phoneNumber = phoneNumber;
  }
}
